<div class="label-wrapper" id="shared-label-select-wrapper" [ngStyle]="labelStyles">
  <div id="shared-label-select-text-wrapper" class="select-label-wrapper">
    <app-text id="shared-label-select-text" [textStyleType]="labelTextType"
      >{{ labelText }}
      <span id="shared-label-select-required" *ngIf="isRequired" class="red-color"
        >*</span
      >
    </app-text>
    <app-tooltip
      *ngIf="showTooltipIcon"
      id="shared-label-select-tooltip"
      [tooltipDelay]="'0'"
      [tootltipText]="toolTipText | translate"
    >
      <div id="shared-label-select-tooltip-content" class="tooltip-content">
        <app-icon
          id="shared-label-select-tooltip-icon"
          [name]="'info_outline'"
          [size]="iconSize"
          [color]="'primary'"
        ></app-icon>
      </div>
    </app-tooltip>
  </div>
</div>
<app-select
  #sharedLabelSelect
  id="shared-label-select-options"
  class="shared-label-select-options"
  [showIcon]="showIcon"
  [isFilterSelect]="isFilterSelect"
  [height]="height"
  [isTransparentSelect]="isTransparentSelect"
  [singleSelectPanelClass]="singleSelectPanelClass"
  [customMatSelectTextClass]="customMatSelectTextClass"
  [isDisabled]="isDisabled"
  [isRequired]="isSelectRequired"
  [defaultValue]="selectedOption"
  [hasCustomError]="hasCustomError"
  [customErrorMsg]="customErrorMsg"
  [selectNoBorder]="selectNoBorder"
  [isThinBorder]="isThinBorder"
  [data]="selectData"
  [placeholder]="placeholder"
  (selectionChangeHandler)="onSelectionChange($event)"
  [singleSelectTextClass]="singleSelectTextClass"
></app-select>
